module.exports = __webpack_public_path__ + "static/media/domkennedy-yellowalbum.3fdb6448.jpg";